import { Box, Button, Divider } from '@mui/material'
import FormField from 'components/FormField'
import { useAPI } from 'contexts/APIProvider'
import { useAuthUser } from 'contexts/AuthUserProvider'
import React from 'react'

// step 1: create guest (anonymous) user with email
// step 2: call backend api to setup guest user with name, console log the result
// step 3: call backend api to get user data, console log the result
// assert user data is correct, both in backend and firebase (name, email, is_guest)
// step 4: link credentials, update backend, and refresh user

const AnonymousUserTest: React.FC = () => {
    const { signInAsGuest, authUser, refreshUser, linkCredentials } = useAuthUser()
    const { api } = useAPI()
    const [firstName, setFirstName] = React.useState<string>('')
    const [lastName, setLastName] = React.useState<string>('')
    const [email, setEmail] = React.useState<string>('')
    const [password, setPassword] = React.useState<string>('')

    const createUser = React.useCallback(async () => {
        const user = await signInAsGuest(email)
        console.log('guest user created', user)
    }, [email, signInAsGuest])

    const setupGuestUser = React.useCallback(async () => {
        if (!authUser) return
        const data = await api.setupGuestUser(firstName, lastName)
        await refreshUser(true)
        console.log('guest user setup', data)
    }, [api, firstName, lastName, authUser, refreshUser])

    const singleOperation = React.useCallback(async () => {
        await signInAsGuest(email)
        const data = await api.setupGuestUser(firstName, lastName)
        await refreshUser(true)
        console.log('guest user setup (single operation)', data)
    }, [api, firstName, lastName, email, signInAsGuest, refreshUser])

    const linkCredentialsToGuestUser = React.useCallback(async () => {
        const user = await linkCredentials(email, password)
        console.log('credentials linked', user)
    }, [email, password, linkCredentials])

    React.useEffect(() => {
        console.log('authUser', authUser)
    }, [authUser])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <h1>Create Guest User</h1>
            <FormField
                name='email'
                label='Email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />
            <Button variant='contained' color='primary' onClick={createUser}>Create User</Button>
            <Divider />
            <h1>Update User Profile</h1>
            <FormField
                name='firstName'
                label='First Name'
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
            />
            <FormField
                name='lastName'
                label='Last Name'
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
            />
            <Button variant='contained' color='primary' onClick={setupGuestUser}>Update User Profile</Button>
            <Divider />
            <h1>Single Operation (Sign In + Setup Guest User)</h1>
            <Button variant='contained' color='primary' onClick={singleOperation}>Single Operation (Sign In + Setup Guest User)</Button>
            <Divider />
            <h1>Link Credentials</h1>
            <FormField
                type='password'
                name='password'
                label='Password'
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />
            <Button variant='contained' color='primary' onClick={linkCredentialsToGuestUser}>Link Credentials</Button>
        </Box>
    )
}

export default AnonymousUserTest
